import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import { showToast } from 'src/utils/showToaster';
import { CircularProgress } from '@mui/material';
import { useGetUserRoleByIdQuery, useUpdateUserRoleByIdMutation } from 'src/services/UserRoleService';
import { UserRoleFormValues } from 'src/models/UserRole.model';
import UserRoleForm from '../Layouts/UserRoleForm';

type Props = {
  onClose: () => void;
  selectedUserRoleId: string
};

const EditUserRoleWrapper = ({ onClose, selectedUserRoleId }: Props) => {
  // Form Initial Values
  const [items, setItems] = useState<any>({});

  const { isLoading, isFetching, data } =
    useGetUserRoleByIdQuery(selectedUserRoleId);
  const [updateUserRoleById] = useUpdateUserRoleByIdMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);
  const initialValues: UserRoleFormValues = {
    roleName: items?.roleName || '',
    module:items?.module || '',
  };
  // Validation Schema
  const validationSchema = object().shape({
    roleName: string().required('Please enter UserRole name'),
  });

  // Handle Submit
  const handleSubmit = (
    values: UserRoleFormValues,
    { setSubmitting, resetForm }: FormikHelpers<UserRoleFormValues>
  ) => {
     const modules = values.module?.map((module) => ({
      moduleId: module.moduleId,
      moduleName: module.moduleName,
      moduleAction: module.moduleAction?.map((action) => ({
        actionId: action.actionId,
        actionName: action.actionName,
        actionUrl: action.actionUrl,
        fields: action.fields,
      })),
    }));

    const payload = {
      roleName: values.roleName,
      module: modules,
    };
    updateUserRoleById({ id: selectedUserRoleId, body: payload }).then(
      (res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      }
    );
  };


  return (
    <Dialog open maxWidth='md' fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <UserRoleForm formikProps={formikProps} onClose={onClose} formType='EDIT' />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditUserRoleWrapper;